import { render, staticRenderFns } from "./orgcontrol.vue?vue&type=template&id=7b1783ed"
import script from "./orgcontrol.vue?vue&type=script&lang=js"
export * from "./orgcontrol.vue?vue&type=script&lang=js"
import style0 from "./orgcontrol.vue?vue&type=style&index=0&id=7b1783ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports